module.exports = __webpack_public_path__ + "img/benefit-info.c8e99788.svg";